import script from "./content-serve.vue?vue&type=script&setup=true&lang=js"
export * from "./content-serve.vue?vue&type=script&setup=true&lang=js"

import "./content-serve.vue?vue&type=style&index=0&id=54653f52&lang=scss"

const __exports__ = script;

export default __exports__